import React from "react";
import { StaticQuery, graphql } from "gatsby";

import {
  Section,
  Card,
  Header2,
  Paragraph,
  Underlined,
  Image,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const EnergyModes = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query EnergyModesImageQuery {
          file(relativePath: { eq: "energy_modes.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt="Someone charging their electric car"
          css={`
            + picture > img,
            img {
              object-position: 10% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 35% 50%;
              }
              @media screen and (min-width: ${getSize("tablet768")}) {
                object-position: 40% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 32px 38px 38px 38px;
        }
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 32px 46px 46px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          width: 388px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          padding: 30px 36px 34px 40px;
          width: 381px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          width: 423px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 76px 80px;
        }
      `}
    >
      <Header2>
        {"Energy Modes"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize("default")}) {
            margin-top: 22px;
          }
        `}
      >
        {
          "Easily switch between modes for your needs at any time. Optimize energy consumption to minimize energy cost. Prioritize use of stored energy and local generation, to reduce grid electricity use or take yourself off the grid at the press of a button."
        }
      </Paragraph>
    </Card>
  </Section>
);
